export default __webpack_public_path__ + "static/media/icon-contact-m.a223b7fb.svg";